import * as React from 'react';
import { DisplayText, ButtonPrimary, FlexRowPanel, Tile, EditableComponentProps, ComplexValue, DisplayCodes, DisplayNumber } from 'ui';
import {
  SetValuesFromResultType
} from 'app/area/case/features/search-external-provider/types';
import styles from './search-external-provider.scss';
import { SearchExternalResultValue } from 'app/area/case/types-store';
import { useCallback } from 'react';
import { replaceTemplateString } from 'app/infrastructure/platform';

interface SearchResultItemProps extends EditableComponentProps<ComplexValue<string | number>> {
  values: SearchExternalResultValue[];
  setValuesFromResult: SetValuesFromResultType;
  textConfirmSelection?: string;
  textFailedToMapCodeValue?: string;
}

interface DisplayResultValueProps {
  componentId?: string;
  value: SearchExternalResultValue;
  textFailedToMapCodeValue?: string;
}

const DisplayResultValue = ({ componentId, value, textFailedToMapCodeValue }: DisplayResultValueProps) => {
  if (value.codeValue) {
    return <DisplayCodes 
      componentId={componentId}
      className="displaycodes col-sm-6 col-xl-4"
      options={undefined}
      onChange={undefined}
      showStacked={true}
      label={{ text: value.description ?? value.dataTag, visible: true }}
      valueItems={[{ value: value.codeValue.v, description: value.codeValue.d }]}
    />;
  }
  else if (value.numberValue !== undefined) {
    return <DisplayNumber
      componentId={componentId}
      className="displaynumber col-sm-6 col-xl-4"
      onChange={undefined}
      options={undefined}
      showStacked={true}
      label={{ text: value.description ?? value.dataTag, visible: true }}
      valueItem={{ value: value.numberValue }}
    />;
  }
  else {
    return <DisplayText
      componentId={componentId}
      className={`displaytext col-sm-6 col-xl-4 ${value.failedToMapCodeValue ? styles.failedToMapCodeValue : ''}`}
      onChange={undefined}
      options={undefined}
      showStacked={true}
      label={{ text: value.description ?? value.dataTag, visible: true }}
      valueItem={{ value: value.failedToMapCodeValue ? replaceTemplateString(textFailedToMapCodeValue, value.value) : value.value }}
    />;
  }
};

// eslint:disable-next-line:function-name
export const SearchResultItem = ({
  values,
  setValuesFromResult,
  textConfirmSelection,
  textFailedToMapCodeValue,
  componentId,
  className
}: SearchResultItemProps) => {
  
  const onSelect = useCallback(() => {
    setValuesFromResult(values);
  }, [values]);

  return (
    <div className={styles.searchResultContainer}>
      <Tile componentId={componentId} className={styles.left}>
        <FlexRowPanel componentId={componentId} className={className}>
          {values.map((v, i) => 
            <DisplayResultValue
              key={i}
              componentId={componentId}
              value={v} 
              textFailedToMapCodeValue={textFailedToMapCodeValue} />
          )}
        </FlexRowPanel>
      </Tile>
      <div className={styles.right}>
        <ButtonPrimary 
          onClick={onSelect}>
            {textConfirmSelection}
        </ButtonPrimary>
      </div>
    </div>
  );
};
